'use client';

declare module '@mui/material/styles' {
    interface Palette {
        disabled: {
            background: string;
            icon: string;
            text: string;
        }
    }
    interface PaletteOptions {
        disabled: {
            background: string;
            icon: string;
            text: string;
        }
    }
}

export enum PinnacleThemes {
    MUI_DEFAULT = 'default',
    BASE_THEME = 'baseTheme',
}

export type IPinnacleThemeProps = {
    theme?: PinnacleThemes;
};